import { render, staticRenderFns } from "./widgetIpsecTunnelTraffic.vue?vue&type=template&id=058ad441&scoped=true&"
import script from "./widgetIpsecTunnelTraffic.vue?vue&type=script&lang=js&"
export * from "./widgetIpsecTunnelTraffic.vue?vue&type=script&lang=js&"
import style0 from "./widgetIpsecTunnelTraffic.vue?vue&type=style&index=0&id=058ad441&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ad441",
  null
  
)

export default component.exports